import {cn} from '../../../../../lib/classname';

export const TagForEngineer: React.FC<{checked?: boolean}> = ({checked}) => (
  <span
    className={cn('ml-8 rounded-16 px-16 text-sm text-white', {
      'border border-white': checked,
      'bg-guild': !checked,
    })}
    style={{display: 'inline-block'}}
  >
    おすすめ
  </span>
);
